import React from "react";
import { Task, TaskType } from "pages/ProjectManagement/ProjectManagement.types";
import { parseListDate } from "helpers/parseListDate";
import { parseSelectOption, customFieldRender } from "../GatewaySummary.utils";
import { TaskSummaryListProps } from "../GatewaySummary.types";
import { sortByOrderNumber } from "../../GatewaysSummary";

/**
 * TaskSummaryList component renders the list of tasks within a gateway
 * Shows task name, description, and metadata when gateway is expanded
 */
export const TaskSummaryList: React.FC<TaskSummaryListProps> = ({
  gateway,
  expand,
  headerGatewayIndex,
  children,
}) => {
  return (
    <div className={`TaskContainer ${expand ? "expanded" : ""}`}>
      {children || (
        <>
          {gateway.tasks
            ?.filter((task) => !task.bHeaderTask)
            .sort(sortByOrderNumber)
            .map((task, index) => {
              const completed = index + 1 <= gateway.completedTasksCount;

              const lastTask =
                index + 1 === gateway.tasks?.length ||
                (headerGatewayIndex !== null && index + 2 === gateway.tasks?.length);

              let nextTaskComplete = false;

              if (gateway.tasks.length > index + 1) {
                let tempNextTaskComplete = gateway.tasks[index + 1].bComplete;

                if (
                  gateway.tasks[index + 1].bHeaderTask &&
                  gateway.tasks.length > index + 2 &&
                  gateway.tasks[index + 2]
                ) {
                  tempNextTaskComplete = gateway.tasks[index + 2].bComplete;
                }
                nextTaskComplete = tempNextTaskComplete;
              }

              return (
                <div
                  className={`TaskSummaryContainer ${task.bHeaderTask ? "HeaderTaskMilestone" : ""}`}
                  key={`${task.taskName}-${task.taskTemplatesID}-${index}`}
                >
                  <div className="TaskSummaryHeader">
                    <div className={`Cirle ${task.bComplete ? "True" : ""}`}></div>
                    <div className="TaskName">
                      {task.taskTemplatesID} - {task.taskName}
                    </div>
                  </div>
                  <ul
                    className={`TaskSummary ${nextTaskComplete ? "True" : ""} ${
                      lastTask ? "LastTask" : ""
                    }`}
                  >
                    {task.description && <li>{task.description}</li>}

                    {task.contactTypes && task.contactTypes.length > 0 && (
                      <li>Contact types - {parseSelectOption(task.contactTypes)}</li>
                    )}
                    {task.siteUsers && task.siteUsers.length > 0 && (
                      <li>Site users - {parseSelectOption(task.siteUsers)}</li>
                    )}
                    {task.documentTypes && task.documentTypes.length > 0 && (
                      <li>Document types - {parseSelectOption(task.documentTypes)}</li>
                    )}
                    {task.taskType === TaskType.MILESTONE && task.plannedDate && (
                      <li>
                        Planned date -{" "}
                        {`${task.plannedDate ? parseListDate(task.plannedDate, false) : ""}`}
                      </li>
                    )}
                    {task.taskType === TaskType.MILESTONE && task.forecastDate && (
                      <li>
                        Forecast date -{" "}
                        {`${task.forecastDate ? parseListDate(task.forecastDate, false) : ""}`}
                      </li>
                    )}
                    {task.taskType === TaskType.MILESTONE && task.actualDate && (
                      <li>
                        Actual date -{" "}
                        {`${task.actualDate ? parseListDate(task.actualDate, false) : ""}`}
                      </li>
                    )}
                    {task.taskType === TaskType.STANDARD_TASK && task.taskResult && (
                      <li>Task result - {task.taskResult}</li>
                    )}
                    {task.customFields &&
                      task.customFields.map((field, fieldIndex) =>
                        customFieldRender(
                          field,
                          false,
                          `custom-field-${field.name || field.id || fieldIndex}`
                        )
                      )}
                  </ul>
                </div>
              );
            })}
        </>
      )}
    </div>
  );
};
